import { render } from "./TestimonialsOne.vue?vue&type=template&id=008df525"
import script from "./TestimonialsOne.vue?vue&type=script&lang=js"
export * from "./TestimonialsOne.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__